import styled from 'styled-components';
import { colors } from '../../../stylesheets';

const AlertWrapper = styled.div`
  position: fixed;
  top: ${({ show }) => (show ? 0 : '-100vh')};
  left: 0;
  right: 0;
  bottom: ${({ show }) => (show ? 0 : '100vh')};
  background-color: ${colors.blackOpacity};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;

export default AlertWrapper;
